import { Alert } from "@/components/ui/Alert";

export type ErrorFieldProps = {
    message: string;
    className?: string;
};

export default function ErrorField({ message, className }: ErrorFieldProps) {
    return (
        <Alert severity="warning" className={className}>
            {message}
        </Alert>
    );
}
